import { NegativeFillDiamond } from 'ui/icons/status/NegativeFillDiamond';
import { MODAL_SIZES, Modal, ModalFooter, ModalHeader } from 'ui/modal';
import { DestructiveButton, PrimaryButton } from 'ui/button';
import { MODAL_CONTENT } from 'modules/anonymousUserTracking/constants';
import { useToggleArchiveAnonCriteria } from 'modules/anonymousUserTracking/hooks/useToggleArchiveAnonCriteria';
import { AnonUserCriteria } from 'modules/graphql/types/GraphQLAnonymousCriteria';
import { colors } from 'ui/theme/colors';
import { ModalHeaderWrapper, StyledModalBody } from '../AnonymousUserTracking.styled';

const {
  ARCHIVE_MODAL_HEADER,
  UNARCHIVE_MODAL_HEADER,
  ARCHIVE_MODAL_BODY,
  UNARCHIVE_MODAL_BODY,
  ARCHIVE_BUTTON_LABEL,
  UNARCHIVE_BUTTON_LABEL,
} = MODAL_CONTENT;

export const CriteriaArchivalModal = ({
  archiving,
  onClose,
  criteria,
  onSuccess,
}: {
  archiving: boolean;
  onClose: () => void;
  criteria: AnonUserCriteria;
  onSuccess?: () => void;
}) => {
  const ButtonCmp = archiving ? DestructiveButton : PrimaryButton;
  const { toggleCriteriaArchive } = useToggleArchiveAnonCriteria(criteria.fields.name);

  const handleConfirm = () => {
    toggleCriteriaArchive({
      variables: {
        id: criteria.id,
        isArchived: archiving,
      },
      onCompleted: () => {
        onSuccess?.();
        onClose();
      },
    });
  };

  return (
    <Modal size={MODAL_SIZES.SMALL} id="criteria-archival-modal" isModalOpen onClose={onClose}>
      <ModalHeader>
        <ModalHeaderWrapper>
          {archiving && <NegativeFillDiamond color={colors.iconDestructive} />}
          {archiving ? ARCHIVE_MODAL_HEADER : UNARCHIVE_MODAL_HEADER}
        </ModalHeaderWrapper>
      </ModalHeader>
      <StyledModalBody>
        {archiving
          ? ARCHIVE_MODAL_BODY(criteria.fields.name)
          : UNARCHIVE_MODAL_BODY(criteria.fields.name)}
      </StyledModalBody>
      <ModalFooter>
        <ButtonCmp onClick={handleConfirm}>
          {archiving ? ARCHIVE_BUTTON_LABEL : UNARCHIVE_BUTTON_LABEL}
        </ButtonCmp>
      </ModalFooter>
    </Modal>
  );
};
